export class CellFormatPart {
  constructor ({ variable, variables, ...config }) {
    Object.keys(config).forEach((key) => {
      this[key] = config[key]
    })

    // support singular or plural, but store as array for consistent downstream processing
    this.variables = variables || []
    if (variable) {
      variable = Array.isArray(variable) ? variable : [ variable ]
      this.variables = this.variables.concat(variable)
    }
  }
}
